module.exports = __webpack_public_path__ + "img/services.3946684e.jpg";